var React = require('react');
var { useCallback } = require('react');
var { connect } = require('react-redux');
var Unicorn = require('./Unicorn');
var {
  getOverlayStyle,
  getClickTargetStyle,
} = require('./UnicornCelebration.styles');

/**
 * UnicornCelebration Component
 * Main overlay component that displays flying unicorns with rainbow trails
 *
 * @param {Object} props
 * @param {boolean} props.isActive - Whether celebration is active
 * @param {boolean} props.isFadingOut - Whether fading out
 * @param {Array} props.unicorns - Array of unicorn configurations
 * @param {Function} props.onDismiss - Callback to dismiss the celebration
 * @param {Function} props.onUnicornComplete - Callback when a unicorn completes
 */
var UnicornCelebration = function (props) {
  var isActive = props.isActive;
  var isFadingOut = props.isFadingOut;
  var unicorns = props.unicorns;
  var onDismiss = props.onDismiss;
  var onUnicornComplete = props.onUnicornComplete;

  var handleClick = useCallback(
    function () {
      if (onDismiss) {
        onDismiss();
      }
    },
    [onDismiss],
  );

  // Don't render if not active
  if (!isActive) {
    return null;
  }

  return React.createElement(
    React.Fragment,
    null,
    // Click target (catches clicks to dismiss)
    React.createElement('div', {
      style: getClickTargetStyle(isFadingOut),
      onClick: handleClick,
      role: 'button',
      tabIndex: 0,
      'aria-label': 'Click to dismiss celebration',
      onKeyDown: function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Escape') {
          handleClick();
        }
      },
    }),
    // Unicorn container
    React.createElement(
      'div',
      {
        style: getOverlayStyle(isFadingOut),
        'aria-hidden': 'true',
      },
      unicorns.map(function (config) {
        return React.createElement(Unicorn, {
          key: config.id,
          config: config,
          isActive: isActive && !isFadingOut,
          onComplete: onUnicornComplete,
        });
      }),
    ),
  );
};

module.exports = UnicornCelebration;
